const overridePaperStyles = theme => ({
	MuiPaper: {
		styleOverrides: {
			root: {
				backgroundColor: theme.palette.background.grey,
				boxShadow: "none",
			},
		},
	},
	MuiAccordion: {
		styleOverrides: {
			root: {
				"&.Mui-expanded": {
					boxShadow: "none",
					backgroundColor: theme.palette.background.grey
				},
			},
		},
	},
	MuiAccordionSummary: {
		styleOverrides: {
			root: {
				minHeight: "0px",
				"&.Mui-expanded": {
					minHeight: "0px",
				},
			},
		},
	},
})

export default overridePaperStyles
